import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import styles from "./StarRating.module.css";

function StarRating({ rating, reviewCount, size = 14 }) {
  const stars = Array.from({ length: 5 }, (_, i) => {
    if (rating >= i + 1) return "full";
    if (rating >= i + 0.5) return "half";
    return "empty";
  });

  return (
    <div className={styles.wrapper}>
      <span className={styles.stars} aria-label={`評分 ${rating} 分`}>
        {stars.map((type, i) => (
          <span key={i} style={{ fontSize: size }}>
            {type === "full" && <FaStar className={styles.filled} />}
            {type === "half" && <FaStarHalfAlt className={styles.filled} />}
            {type === "empty" && <FaRegStar className={styles.empty} />}
          </span>
        ))}
      </span>
      {reviewCount !== undefined && (
        <span className={styles.count}>({reviewCount})</span>
      )}
    </div>
  );
}

export default StarRating;
